<div class="card" *ngFor="let data of dataArray">
    <h6 class="header">{{data.header}}</h6>
    <div class="content">
        <div *ngFor="let content of data.content">
            <div [ngClass]="content.error ? 'error' : ''">
                <img *ngIf="content.statesFlag && !content.error" src="./../../../assets/images/checkmark.svg">
                <img *ngIf="content.statesFlag && content.error" src="./../../../assets/images/errormark.svg">
                <span class="name">{{getRoleName(content.name)}}</span>
                <span class="number" *ngIf="content.countFlag"
                    [ngClass]="(currLang == 'en' ? 'float-right' : 'float-left')">
                    {{content.count}}
                </span>
                <p class="errormsg" (click)="errorClicked(content)"
                    *ngIf="content.error && type !=='gates' && type!=='grades'">{{content.error}}</p>
            </div>
        </div>
    </div>
</div>